import { useTranslation } from 'react-i18next';
import { useContext } from '@/components/slider-type/context';
import { cn } from '@/utils/helper';
import v1 from './paragraph-v1.module.css';
import v2 from './paragraph-v2.module.css';

export default function Paragraph() {
  const { slide } = useContext();
  const { t } = useTranslation();

  return (
    <div className={cn(v1.Paragraph, v2.Paragraph)} dangerouslySetInnerHTML={{ __html: t(slide.content || '') }} />
  );
}
